<template>
    <div class="person">
        <div class="condition">
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="140px" :search="selectData" :reset="reset"></queryCondition>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <el-table-column prop="userId" label="用户ID" align="center" width="100px"></el-table-column>
                <el-table-column prop="header" label="头像" align="center" width="80px">
                    <template slot-scope="scope">
                        <el-image
                            v-if="scope.row.header"
                            style="width: 40px; height: 40px; border-radius: 50%;"
                            :src="scope.row.header"
                            :preview-src-list="[scope.row.header]"
                            fit="cover">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="nickName" label="昵称" align="center" width="140px"></el-table-column>
                <el-table-column prop="phone" label="手机号" align="center" width="140px"></el-table-column>
                <el-table-column prop="customMessage" label="自动回复内容" align="center" min-width="200px" show-overflow-tooltip></el-table-column>
                <el-table-column prop="customMessageState" label="审核状态" align="center" width="120px">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.customMessageState === 0" type="warning" size="small">审核中</el-tag>
                        <el-tag v-else-if="scope.row.customMessageState === 1" type="success" size="small">审核通过</el-tag>
                        <el-tag v-else-if="scope.row.customMessageState === -1" type="danger" size="small">审核不通过</el-tag>
                        <span v-else>{{ scope.row.customMessageState }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="customMessageEnable" label="是否开启" align="center" width="100px">
                    <template slot-scope="scope">
                        {{ scope.row.customMessageEnable ? '已开启' : '未开启' }}
                    </template>
                </el-table-column>
                <el-table-column prop="creationTime" label="创建时间" align="center" width="180px"></el-table-column>
                <el-table-column label="操作" align="center" width="120px">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" size="mini" @click="openAudit(scope.row)">审核</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionData.current"
                    :page-size="conditionData.size">
                </el-pagination>
            </div>
        </div>

        <el-dialog :close-on-click-modal="false" :visible.sync="isAuditDialog" title="审核自定义消息" width="560px">
            <div class="dialog">
                <div class="item">
                    <div class="label">自动回复内容</div>
                    <div class="value" style="width:360px">
                        <el-input v-model="updateData.customMessage" type="textarea" :rows="4" placeholder="自动回复内容"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">审核状态</div>
                    <div class="value">
                        <el-select v-model="updateData.customMessageState" placeholder="请选择">
                            <el-option label="审核中" :value="0"></el-option>
                            <el-option label="审核通过" :value="1"></el-option>
                            <el-option label="审核不通过" :value="-1"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">是否开启</div>
                    <div class="value">
                        <el-switch v-model="updateData.customMessageEnable"></el-switch>
                    </div>
                </div>
                <div class="item" style="justify-content: flex-end; padding-right: 20px;">
                    <el-button @click="isAuditDialog = false">取消</el-button>
                    <el-button type="primary" @click="submitAudit">确认</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
export default {
    name: 'customMessage',
    components:{
        queryCondition,
    },
    data () {
        return {
            totalCount:0,
            tableData:[],
            isAuditDialog: false,
            updateData:{
                id: null,
                creationTime: '',
                userId: null,
                customMessage: '',
                customMessageState: 0,
                customMessageEnable: true,
            },
            conditionData:{
                userId:'',
                phone:'',
                nickName:'',
                customMessageState:'',
                customMessageEnable:'',
                current:1,
                size:10,
            },
            queryList:[
                {type: "input",label: "用户ID:",name: "userId"},
                {type: "input",label: "手机号:",name: "phone"},
                {type: "input",label: "昵称:",name: "nickName"},
                {type: "select",label: "审核状态:",name: "customMessageState",options:[
                    {label:'全部',value:''},
                    {label:'审核中',value:0},
                    {label:'审核通过',value:1},
                    {label:'审核不通过',value:-1},
                ]},
                {type: "select",label: "是否开启:",name: "customMessageEnable",options:[
                    {label:'全部',value:''},
                    {label:'已开启',value:true},
                    {label:'未开启',value:false},
                ]},
            ],
        }
    },
    mounted(){
        setTimeout(() => {
            this.loadingData();
        }, 300)
    },
    methods:{
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let params = {
                current: this.conditionData.current,
                size: this.conditionData.size,
            };
            if (this.conditionData.userId) {
                params.userId = this.conditionData.userId;
            }
            if (this.conditionData.phone) {
                params.phone = this.conditionData.phone;
            }
            if (this.conditionData.nickName) {
                params.nickName = this.conditionData.nickName;
            }
            if (this.conditionData.customMessageState !== '') {
                params.customMessageState = this.conditionData.customMessageState;
            }
            if (this.conditionData.customMessageEnable !== '') {
                params.customMessageEnable = this.conditionData.customMessageEnable;
            }
            let res = await api.CustomMessageQuery(params);
            this.tableData = res.data.data.records || [];
            this.totalCount = res.data.data.total || 0;
        },
        selectData(){
            this.conditionData.current = 1;
            this.loadingData();
        },
        reset(){
            this.conditionData = {
                userId:'',
                phone:'',
                nickName:'',
                customMessageState:'',
                customMessageEnable:'',
                current:1,
                size:10,
            };
            this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.current = page;
            this.loadingData();
        },
        handleSizeChange(pageSize){
            this.conditionData.current = 1;
            this.conditionData.size = pageSize;
            this.loadingData();
        },
        openAudit(row){
            this.updateData = {
                id: row.id,
                creationTime: row.creationTime,
                userId: row.userId,
                customMessage: row.customMessage,
                customMessageState: row.customMessageState,
                customMessageEnable: row.customMessageEnable,
            };
            this.isAuditDialog = true;
        },
        async submitAudit(){
            let res = await api.CustomMessageUpdate(this.updateData);
            if(res.data.code == 200 || res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '审核成功'
                });
                this.isAuditDialog = false;
                this.loadingData();
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .dialog{
        .item{
            display: flex;
            align-items: flex-start;
            margin-bottom: 18px;
            .label{
                width: 120px;
                text-align: right;
                padding-right: 12px;
                line-height: 32px;
                color: #606266;
            }
            .value{
                flex: 1;
            }
        }
    }
</style>
